<template>
  <draggable class="dragArea list-group w-full">
    <slot></slot>
  </draggable>
</template>
<script>
import { defineComponent } from "vue";
import { VueDraggableNext } from "vue-draggable-next";
export default defineComponent({
  components: {
    draggable: VueDraggableNext,
  },
  data() {
    return {
      enabled: true,

      dragging: false,
    };
  },
});
</script>